<template>
  <page :setup="setup">
    <el-tabs class="est-tabs" v-model="tab" @tab-click="tabClick">
      <el-tab-pane label="概算参数" name="form">
        <form-estimate
          :formData="formData"
          :data="data"
          @reset="reset"
          @save="save"
        />
      </el-tab-pane>
      <el-tab-pane label="概算结果" name="result">
        <el-tabs v-model="resultTab">
          <el-tab-pane label="工程概算汇总表" name="result1">
            <summary-table :result="result" />
          </el-tab-pane>
          <!-- <el-tab-pane label="主要技术经济指标表" name="result2">
            主要技术经济指标表
          </el-tab-pane> -->
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
  </page>
</template>

<script>
import SummaryTable from './components/summary-table';

export default {
  components: {
    SummaryTable
  },
  props: {},
  data() {
    return {
      data: null,
      formData: null,
      tab: 'form',
      resultTab: 'result1',
      result: null
    };
  },
  methods: {
    async setup() {
      const data = await this.getEstimateParam();
      this.data = data;
      this.reset();
    },
    async getEstimateParam() {
      const res = await this.$fetch({
        url: '/windfarm/economic/getEstimateParam',
        params: {
          windfarmId: this.$route.query.windfarmId
        },
        showLoading: false
      });
      return res.data;
    },
    async getEstimateResult(showLoading, confirm) {
      const res = await this.$fetch({
        url: '/windfarm/economic/getEstimateResult',
        params: {
          windfarmId: this.$route.query.windfarmId,
          confirm
        },
        showLoading,
        showError: true
      });
      return res.data.estimateResult;
    },
    reset() {
      this.formData = { ...(this.data.investInput || {}) };
      //console.log('reset form', this.formData, this.data);
    },
    async save() {
      //console.log('this.formData', this.formData);
      const res = await this.$fetch({
        url: `/windfarm/economic/saveEstimateResult`,
        method: 'post',
        data: {
          ...this.formData,
          windfarmId: this.$route.query.windfarmId
        },
        showError: true,
        showLoading: true,
        showSuccess: true
      });
      console.log('res', res);
      try {
        this.switchToResult();
      } catch (e) {
        if (e.res && e.res.code === 2) {
          this.$confirm(e.res.message, '请确认', {
            distinguishCancelAndClose: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false
          }).then(() => {
            this.switchToResult(true);
          });
        }
      }
    },
    tabClick(tab) {
      if (tab && tab.name === 'result') {
        if (!this.result) {
          this.switchToResult();
        }
      }
    },
    async switchToResult(confirm) {
      const result = await this.getEstimateResult(true, confirm);
      this.result = result;
      this.tab = 'result';
    }
  }
};
</script>

<style lang="less">
.est-tabs {
  background: #f1f6fa;

  /deep/.el-tabs__header {
    margin-left: 20px;
  }

  /deep/.el-tabs__content {
    background: #f1f6fa;
  }
}
</style>
